import request from './service/index';

export function translate_Api(data) {
    return request({
        url: 'CMS/tools/translate',
        method: 'post',
        data: data
    });
}

// html_text
// language_flag   1: 中译英  2: 英译中



export function textStopWord_Api(data) {
    return request({
        url: 'CMS/tools/stop_word_check',
        method: 'post',
        data: data
    });
}

export function city_Api() {
    return request({
        url: 'CMS/tools/heritage_city_drop_down',
        method: 'get',
    });
}




// WEBPACK FOOTER //
// ./src/apis/tools.api.js